import type { SVGProps } from "react";

export default function AddIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 21, height = 21, ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.2188 6.70239V13.7336"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.70312 10.218H13.7344"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9883 18.1094C13.5968 18.9523 11.9644 19.4375 10.2187 19.4375C5.12738 19.4375 1 15.3101 1 10.2187C1 5.12734 5.12738 1 10.2187 1C15.3102 1 19.4375 5.12734 19.4375 10.2187C19.4375 12.112 18.8538 13.8719 17.875 15.3359"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
